module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/4b922d9f5704a74027f76dae8f54a1fd.png";